module.exports = __webpack_public_path__ + "static/media/25015.a02b11e6.jpg";